import { TraceAbilityState ,initialTraceAbilityState} from '../state/traceability.state';
import { TraceabilityActions, TraceabilityAction } from '../actions/traceability.action';

export function TraceabilityReducers(state = initialTraceAbilityState, action: TraceabilityAction): TraceAbilityState {
    switch (action.type) {
        case TraceabilityActions.GetRecLotByRecLotIdSuccess: {
            return {
                ...state,
                getRecLotByRecLotIdSuccess: action.payload,
                getRecLotByRecLotIdError: null
            };
        }
        case TraceabilityActions.GetRecLotByRecLotIdError: {
            return {
                ...state,
                getRecLotByRecLotIdError: action.payload,
                getRecLotByRecLotIdSuccess: null
            };
        }
        case TraceabilityActions.GetMLCByInternalCodeSuccess: {
            return {
                ...state,
                getMLCByInternalCodeSuccess: action.payload,
                getMLCByInternalCodeError: null
            };
        }
        case TraceabilityActions.GetMLCByInternalCodeError: {
            return {
                ...state,
                getMLCByInternalCodeError: action.payload,
                getMLCByInternalCodeSuccess: null
            };
        }
        case TraceabilityActions.GetRecLotByMaterialIdSuccess: {
            return {
                ...state,
                getRecLotByMaterialIdSuccess: action.payload,
                getRecLotByMaterialIdError: null
            };
        }
        case TraceabilityActions.GetRecLotByMaterialIdError: {
            return {
                ...state,
                getRecLotByMaterialIdError: action.payload,
                getRecLotByMaterialIdSuccess: null
            };
        }
        case TraceabilityActions.GetMLCsByFormulaIdSuccess: {
            return {
                ...state,
                getMLCsByFormulaIdSuccess: action.payload,
                getMLCsByFormulaIdError: null
            };
        }
        case TraceabilityActions.GetMLCsByFormulaIdError: {
            return {
                ...state,
                getMLCsByFormulaIdError: action.payload,
                getMLCsByFormulaIdSuccess: null
            };
        }
        case TraceabilityActions.GetProductTraceabilitySuccess: {
            return {
                ...state,
                getProductTraceabilitySuccess: action.payload,
                getProductTraceabilityError: null
            };
        }
        case TraceabilityActions.GetProductTraceabilityError: {
            return {
                ...state,
                getProductTraceabilityError: action.payload,
                getProductTraceabilitySuccess: null
            };
        }
        case TraceabilityActions.GetMaterialTraceabilitySuccess: {
            return {
                ...state,
                getMaterialTraceabilitySuccess: action.payload,
                getMaterialTraceabilityError: null
            };
        }
        case TraceabilityActions.GetMaterialTraceabilityError: {
            return {
                ...state,
                getMaterialTraceabilityError: action.payload,
                getMaterialTraceabilitySuccess: null
            };
        }
        default: {
            return state;
        }
    }
}